export const getGradientBackgroundStyle = () =>
  `linear-gradient(135deg, #0F766E 0%, #0D9488 40%, #14B8A6 100%)`;
